<template>
    <v-col cols="12" md="12" sm="12" xs="12">
        <v-text-field density="compact" variant="outlined" v-model="form.lead.company" label="Company Name (optional)"/>
    </v-col>
    <v-col cols="12" md="6"  sm="12" xs="12">
        <v-text-field density="compact" :rules="rules" variant="outlined" v-model="form.lead.firstname" label="First Name *"/>
    </v-col>
    <v-col cols="12" md="6"  sm="12" xs="12">
        <v-text-field density="compact" :rules="rules" variant="outlined" v-model="form.lead.lastname" label="Last Name *"/>
    </v-col>
    <v-col cols="12" md="6"  sm="12" xs="12">
        <v-text-field density="compact" :rules="rules" variant="outlined" v-model="form.lead.email" label="Email *"/>
    </v-col>
    <v-col cols="12" md="6"  sm="12" xs="12">
        <v-text-field density="compact" :rules="rules" variant="outlined" v-model="form.lead.phone" label="Phone *"/>
    </v-col>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const store = useGlobalsStore()
const { form } = storeToRefs(store)

const rules = [
  (v: any) => !!v || 'This field is required'
]
</script>
